import React from 'react';
//CSS Import
import '../../css/QuestionWithImage.css'



const AnswerTypeTextbox = function(props) {
   

   
return  <div style={{marginTop:'2%',textAlign:'left',width:'100%'}}> 
            
                <textarea type ="text" name = "selectedAnswer" 
                    onChange={(event)=>props.onAnswerChoice(event.target.value)}  
                    style={{margin:"auto",width:'inherit',minHeight:"25vh"}} />        
            
        </div>
};
export default AnswerTypeTextbox;